import { EmbarqueTemplate } from "../../models/EmbarqueTemplate";
import { api } from "./UrlPadrao";

interface SearchParams {
	token: string;
	pesquisa?: string;
}

export const getEmbarqueTemplateSearch = async ({
	token,
	pesquisa,
}: SearchParams): Promise<EmbarqueTemplate[]> => {
	const response = await api.get<EmbarqueTemplate[]>(
		"SearchPredicate/search/EmbarqueTemplete?" + pesquisa,
		{
			headers: {
				Authorization: token,
			},
		}
	);
	return response.data;
};
